import React, { useEffect, useState } from 'react';
import Immutable, { List } from 'immutable';

import './style.scss';
import ColleagueCollageItem from './Item';

const ColleagueCollage = ({ entities }) => {
  const [isMobile, setIsMobile] = useState(false);

  const splitIntoChunks = (list, chunkAmount = 1) => {
    if (list.count() === 0) {
      return List();
    }

    const chunkSize = list.count() / chunkAmount;

    return Immutable.Range(0, list.count(), chunkSize)
      .map((chunkStart) => {
        return list.slice(chunkStart, chunkStart + chunkSize);
      });
  };

  const handleResize = () => {
    if (window.innerWidth <= 760) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  const rows = splitIntoChunks(entities, 3);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    if (window.innerWidth <= 760) {
      setIsMobile(true);
    }

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="ColleagueCollage">
      {rows.map((entitiesChunk, index) => (
        <div key={`colleague-collage-row-${(index + 1)}`} className="ColleagueCollage__row">
          {entitiesChunk.map((entity) => {
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);

            return <ColleagueCollageItem key={`${uuid}:${langcode}`} entity={entity} mobile={isMobile} />;
          })}
        </div>
      ))}
    </div>
  );
};

export default ColleagueCollage;
